import React, { useEffect, useState } from 'react'
import RecruiterDashboardHeader from '../Components/RecruiterDashboardHeader'
import RecruiterHeaderComponent from '../Components/RecruiterHeaderComponent'
import CandidateCardForRecruiter from '../Components/CandidateCardForRecruiter'
import { CandidateProfile, CandidateTotalCountResponse, initialCandidateProfile } from '../../Candidate/Types/CandidateType';
import { getAllCandidates, getCandidatesTotalStats } from '../../Candidate/Services/CandidateService';
import { getJobTemplateByCompanyRecruiterId } from '../../JobPostTemplate/Services/JobPostTemplateService';
import HorizontalFilterBar from '../../SearchFilter/Components/HorizontalFilterBarComponent';
import { getAllSearchFilters, getAllSearchFiltersBySubscriptionPlan } from '../../SearchFilter/Services/SearchFilterService';
import SmartFilterSystemPage from '../../SearchFilter/Pages/SmartFilterSystemPage';
import QuickSmartFilterSystem from '../../SearchFilter/Components/QuickSmartFilterSystem';
import LoadMoreButton from '../../Shared/Pagination/LoadMoreButton';
import { SearchFilterResponse } from '../../SearchFilter/Types/SerachFileter';
import { storage } from '../../Shared/Utils/authStorage';
import { CandidateSearch } from '../Components/CandidateSearch';
import ExecutiveSearchPortalLight from '../SearchComponents/ExecutiveSearchPortalLight';
import { CandidateSearchWithStats } from '../Components/CandidateSearchWithStats';
import { getAllCandidateStatsByStatus } from '../Services/RecruiterService';
import { useParams } from 'react-router-dom';

function RecruiterCandidateListingByStatusPage() {


   const [filterBySubscriptionPlan, setFilterBySubscriptionPlan] = useState<SearchFilterResponse []>([]);
   const [candidatesStats, setCandidatesStats] = useState<CandidateTotalCountResponse>();
   const [candidates, setCandidates] = useState<CandidateProfile[]>([]);
   
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const { status } = useParams();
    const [page, setPage] = useState(0);
    const [pagination, setPagination] = useState({
      page: 0,
      size: 2,
      totalElements: 0,
      totalPages: 0,
      first: true,
      last: false,
      hasNext: false,
      hasPrevious: false,
    });

    

    useEffect(() => {
      const fetchCandidate = async () => {
        try {
          setLoading(true);
    
          const response = await getAllSearchFiltersBySubscriptionPlan(
            storage.getUserId() ?? ""
          );
    
          const candidateTotalStats = await getCandidatesTotalStats();
    
          const payload = {
            candidateStatsByStatus: status,
          };
    
          const candidateProfiles = await getAllCandidateStatsByStatus(payload, page);
    
          if (response.success) {
            setFilterBySubscriptionPlan(response.data);
            setCandidatesStats(candidateTotalStats.data);
            // setCandidates(candidateProfiles.data.content);

            // setCandidates((prev) => [
            //   ...prev,
            //   ...candidateProfiles.data.content
            // ]);

            setCandidates((prev) =>
              page === 0
                ? candidateProfiles.data.content
                : [...prev, ...candidateProfiles.data.content]
            );


            setPagination({
              page: candidateProfiles.data.page,
              size: candidateProfiles.data.size,
              totalElements: candidateProfiles.data.totalElements,
              totalPages: candidateProfiles.data.totalPages,
              first: candidateProfiles.data.first,
              last: candidateProfiles.data.last,
              hasNext: candidateProfiles.data.hasNext,
              hasPrevious: candidateProfiles.data.hasPrevious,
            });
          }
        } catch (err) {
          console.error(err);
          setError("An unexpected error occurred while loading the profile.");
        } finally {
          setLoading(false);
        }
      };
    
      fetchCandidate();
    }, [page, status]);


     



  return (
    <div>

    <CandidateSearchWithStats searchFilterData={filterBySubscriptionPlan} candidatesTotalStats={candidatesStats} filterStatus={candidates}   pagination={pagination}  
    
  page={page}
  setPage={setPage}
    />
  

</div>
  )
}

export default RecruiterCandidateListingByStatusPage